import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching products with pagination
export const fetchProducts = createAsyncThunk(
    'product/fetchProducts',
    async ({ page = 1, limit = 15, category, sortBy, search, minPrice, maxPrice }, { rejectWithValue }) => {
        try {
            // Build query parameters
            const params = new URLSearchParams();
            params.append('page', page);
            params.append('limit', limit);
            
            if (category) params.append('category', category);
            if (sortBy) params.append('sortBy', sortBy);
            if (search) params.append('search', search);
            if (minPrice) params.append('minPrice', minPrice);
            if (maxPrice) params.append('maxPrice', maxPrice);
            
            const response = await axios.get(`https://pavitra-server-murex.vercel.app/api/product/all-enabled?${params.toString()}`);
            
            // Add default pagination if the API doesn't provide it
            if (!response.data.pagination) {
                response.data.pagination = {
                    currentPage: page,
                    totalPages: Math.ceil((response.data.products.products || []).length / limit),
                    totalItems: (response.data.products.products || []).length,
                    limit
                };
            }
            
            return response.data;
        } catch (error) {
            console.error("Error fetching products:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const productSlice = createSlice({
    name: 'product',
    initialState: {
        products: [],
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            limit: 15
        },
        filters: {
            category: '',
            sortBy: '',
            search: '',
            minPrice: '',
            maxPrice: ''
        }
    },
    reducers: {
        setProducts(state, action) {
            state.products = action.payload;
        },
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                category: '',
                sortBy: '',
                search: '',
                minPrice: '',
                maxPrice: ''
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.status = 'succeeded';
                
                // Safely extract products
                state.products = action.payload.products?.products || [];
                
                // Safely extract pagination data
                state.pagination = action.payload.pagination || {
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: state.products.length,
                    limit: 15
                };
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch products';
                console.error("Product fetch failed:", state.error);
            });
    }
});

export const { setProducts, setFilters, resetFilters } = productSlice.actions;
export default productSlice.reducer;
